/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 年間スケジュールマスタ検索情報
 */
export interface Szza024aRequestNenkanSchdlMasterSrchInfDto { 
    /**
     * 日付識別：数字<br>　　画面項目ID＝\'C000660\'
     */
    dateDiscrm?: string | null;
    /**
     * スケジュールグループ番号：数字
     */
    grpNo?: string | null;
    /**
     * 日付（年）：数字
     */
    year?: string | null;
    /**
     * 月：数字
     */
    month?: string | null;
    /**
     * 適用開始日付（From）：日付(yyyyMMdd)
     */
    applyStartDateFrom?: string | null;
    /**
     * 適用開始日付（To）：日付(yyyyMMdd)
     */
    applyStartDateTo?: string | null;
}

